import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '../../../common/entityFramework/entityView/EntityMgrContext';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ValList } from '@/common/val/ValList';
import { McdDispList } from '@/sc/entities/mcdDisp/McdDispList';

export const McdInvLineDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'inv', label: 'Invoice', content: <EntityForm entity="MCD_INV" entityId={entityObj.mcdInvId} /> },
    { id: 'disps', label: 'Disputes', content: <McdDispList mcdInvLineId={entityObj.id} />},
    { id: 'validations', label: 'Validations', content: <ValList parentEntity="MCD_INV_LINE" parentEntityId={entityObj.id} /> },
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}